// extracted by mini-css-extract-plugin
module.exports = {"appointment-form__name-column":"_3c7OqndG5fDwVghR2Bic9s","appointment-form__name-row":"Z7KxcuKa0RJobx7sSHN7H","appointment-form__info":"_3pxyaInpSU6bVE79hGNilW"};